import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLIC_KEY } from '../../config';
import { useLang } from '../hooks/useLanguage';
import { toStripeLocale } from '../helpers/stripeLocale';

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

function StripeContext({ children }: { children: React.ReactNode }) {
    const { language } = useLang();
    // Default-Elements wrapper. Without an explicit locale, Stripe.js reads
    // navigator.language which can be `hu-HU` (an IETF tag Stripe doesn't
    // support in Elements). Pass the widget's normalized short code so the
    // first Payment Element session and every remount use a supported tag.
    return (
        <Elements stripe={stripePromise} options={{ locale: toStripeLocale(language) }}>
            {' '}
            {children}
        </Elements>
    );
}
export default StripeContext;
